module.exports = __webpack_public_path__ + "static/media/excel-academy-logos.d8dde0ce.png";